<template>
  <div v-if="cartItem.details && cartItem.details.options.length" class="component option-choices">

    <div class="option-wrapper">
      <h3>{{$t("general.label.additional-offers")}}</h3>

      <div class="single-option" v-for="(option, index) in cartItem.details.options" :key="`option-${index}`">

        <div class="option-input">
          <div>
            <label class="option-name">{{ option.name }}</label>
            <div class="option-price">{{ $formatter.currency(option.price) }}</div>
          </div>
          <quantity-picker @input="$emit('change', option)" :active="active" v-model="cartItem.options[index].value" :min="option.selectionMin" :max="option.selectionMax" />
        </div>
        <div class="option-description">{{ option.description }}</div>
      </div>
    </div>
  </div>
</template>

<script>

import QuantityPicker from '@/components/QuantityPicker.vue';

export default {
  props: ['cartItem', 'active'],

  components: {
    QuantityPicker
  },

  computed: {
  },

  created() {
  },

  methods: {
  }
}

</script>

<style lang="scss">
.component {
  margin-bottom: 25px;
}

.single-option {
  margin-bottom: 20px;
}

.single-option:last-child {
  margin-bottom: 0;
}

.option-wrapper {
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
}

.option-wrapper h3 {
  margin-bottom: 12px;
}
</style>